export default __webpack_public_path__ + "MJEMonitoringSampleFile.0f6f513d.png";